import { Component, OnInit } from '@angular/core';
import { NavService } from 'src/app/services/nav.service';

@Component({
  selector: 'app-linkedin-feed',
  templateUrl: './linkedin-feed.component.html',
  styleUrls: ['./linkedin-feed.component.scss']
})
export class LinkedinFeedComponent implements OnInit {

  constructor(
    public nav: NavService
  ) { }

  ngOnInit() {
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
